// extracted by mini-css-extract-plugin
export var Hover = "hover-module--Hover--Jd7sU";
export var HoverShown = "hover-module--HoverShown--3zv9Q";